export default __webpack_public_path__ + "static/media/Spinner.f406a950.gif";